
import { FC } from 'react';

export const TRUE_FALSE = [{ key: 'true', label: 'Yes' }, { key: 'false', label: 'No' }];

export interface IBooleanRadioProps {
  onChange: (value: boolean) => void;
  name: string;
  value?: boolean;
  error?: string;
  readOnly?: boolean;
}

export const BooleanRadio: FC<IBooleanRadioProps> = ({ onChange, value, error, name, readOnly }) => {
  return <div className='cb-radio-custom'>{TRUE_FALSE.map((option) => {
    return <label key={`${name}-${option.key}-boolean-radio`}>
      <input disabled={readOnly} className='cb-radio-style' type='radio' checked={`${value}` === option.key ? true : false} onChange={() => { onChange(option.key === 'true' ? true : false); }}></input> {option.label}
    </label>;
  })}
    {error &&
      <span style={{ marginTop: '2px', marginBottom: '8px' }} className='cb-input-helper cb-validation-error'>{error}</span>
    }
  </div>;
};